const EN = {
    title: 'Movimientos',
    table: {
        title: 'Listado de movimientos',
        columns: {
            id: 'ID GP',
            gpaccount: 'Cuenta GP',
            date: 'Fecha y hora',
            code: 'Codigo',
            type: 'Tipo',
            amount: 'Importe',
            client: 'Cliente',
            document: 'INE',
            lastFour: 'Últimos 4',
            commerce: 'Comercio'
        },
        types: {
            authorization: 'Autorización',
            collection: 'Cobranza',
            partner_adjustment: 'Ajuste Socio',
            rejection: 'Rechazo',
            cancellation: 'Anulación'
        },
        filter: {
            0: {
                title: 'Por código',
                0: '501',
                1: '802'
            },
            1: {
                title: 'Por tipo',
                0: 'Autorización',
                1: 'Rechazo',
                2: 'Anulacíon'
            },
            2: {
                title: 'Por comercio',
                0: 'Natura',
                1: 'Avon'
            }
        },
    }
};

export default EN;
